import { PANIC_BUTTON_SUBMIT, PRIORITY_CONNECT_SUBMIT } from '@actions/types'

export const panicButtonAction = ({ auth, data }) => ({
  type: PANIC_BUTTON_SUBMIT,
  payload: {
    request: {
      method: 'post',
      url: 'panic',
      data,
      headers: { 'x-api-key': auth.apiKey }
    },
    setLoading: {
      meta: null
    }
  }
})

export const priorityConnectAction = ({ auth, data }) => ({
  type: PRIORITY_CONNECT_SUBMIT,
  payload: {
    request: {
      method: 'post',
      url: 'panic/video',
      data,
      headers: { 'x-api-key': auth.apiKey }
    },
    setLoading: {
      meta: null
    }
  }
})
